<button
	mat-icon-button
	[matMenuTriggerFor]="menu"
	#menuTrigger="matMenuTrigger">
	@if (isEnabled) {
		<mat-icon
			[matBadge]="getBadgeNumber()"
			[matBadgeHidden]="getBadgeNumber() === 0"
			matBadgeColor="warn">
			notifications
		</mat-icon>
	}
	@if (!isEnabled) {
		<mat-icon>notifications_off</mat-icon>
	}
</button>
<mat-menu #menu="matMenu">
	@for (item of messages; track item.id) {
		<button
			mat-menu-item
			(click)="OnClickItem($event, item)">
			<div class="flex flex-row items-center gap-x-4">
				@if (!item.isRead) {
					<span class="text-4xl text-blue-300">&#8226;</span>
				}
				@if (item.type === NotificationType.EMAIL_FAILURE) {
					<mat-icon class="!m-0 text-red-600">unsubscribe</mat-icon>
				}
				<span>{{ item.subject }}</span>
			</div>
		</button>
	}
	<mat-divider />
	<button
		mat-menu-item
		(click)="showHistory()">
		<mat-icon>history</mat-icon>
		{{ "notification.history" | translate }}
	</button>
</mat-menu>
